<template>
  <div class="customer">
    <div class="box">
      <div class="columns">
        <div class="column is-9">
          <p class="title has-text-primary">
            {{ $store.state.customers.temporal.rfc }}
          </p>
          <p class="title has-text-primary">
            {{ $store.state.customers.temporal.name }}
          </p>
        </div>
        <div class="column level-right">
          <div class="columns">
            <div class="column is-4">
              <p class="title is-4 has-text-primary level-left">
                Deuda total
              </p>
            </div>
            <div class="column">
              <p
                v-for="debt in $store.state.customers.temporal.debtsCustomer"
                :key="debt._id.customer"
                class="is-4 title has-text-info level-left"
              >
                {{ debt.totalAmount | toCurrency(debt._id.currency) }}
              </p>
            </div>
          </div>

          <div class="columns">
            <div class="column is-4">
              <p class="title is-4 has-text-primary level-left">
                Deuda vencida
              </p>
            </div>
            <div class="column">
              <p
                v-for="debt in $store.state.customers.temporal.debtsExpired"
                :key="debt._id.customer"
                class="title is-4 has-text-danger level-left"
              >
                {{ debt.totalAmount | toCurrency(debt._id.currency) }}
              </p>
            </div>
          </div>

          <div
            v-if="$store.state.customers.temporal.creditLimit > 0"
            class="columns"
          >
            <div class="column is-4">
              <p class="title is-4 has-text-primary level-left">
                Crédito disponible
              </p>
            </div>
            <div class="column">
              <p
                v-for="debt in $store.state.customers.temporal.debtCreditLimit"
                :key="debt._id.customer"
                class="is-4 title has-text-info level-left"
              >
                {{ $store.state.customers.temporal.creditLimit - debt.totalAmount | toCurrency('MXN') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="columns is-multiline">
      <div class="column is-5">
        <div class="box">
          <section class="modal-card-body">
            <div class="columns is-multiline">
              <div class="column is-12">
                <Customer
                  v-if="loaded"
                  :loading="loading"
                />
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="column">
        <div class="box">
          <IssoComments
            v-if="loaded"
            class="box"
            :loading="loading"
          />
        </div>
      </div>
    </div>
    <InvoicesHistory />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'StatusAccountDetail',
  components: {
    Customer: () => import(/* webpackChunkName: "new-customer" */ '@/components/Customer/New.vue'),
    IssoComments: () => import(/* webpackChunkName: "customers-invoices-history" */ '@/components/Isso/Isso.vue'),
    InvoicesHistory: () => import(/* webpackChunkName: "invoices-history-status-account" */ '../../components/Admin/Customer/InvoicesHistoryStatusAccount.vue'),
  },
  data() {
    return {
      isLoading: false,
      buttonsMax: 5,
      modal: false,
      invoiceToCanel: '',
      loaded: false,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      total: state => state.invoices.total,
      totalPages: state => state.invoices.totalPages,
    }),
    ...mapGetters({
      invoices: 'invoices/cleanInvoices',
    }),
    issoId() {
      return `/${this.$store.state.customers.temporal.customerId}/${this.$store.state.customers.temporal.companyId}`;
    },
  },

  beforeRouteEnter(to, from, next) {
    if (to.query.page) next();
    else {
      next({ name: to.name, query: { page: 1, size: 20, voucherType: 'I|E|P|T' } });
    }
  },

  async beforeRouteUpdate(to, from, next) {
    const token = sessionStorage.getItem('customer_access_token');

    await this.getAll({
      ...to.query,
      token,
    });

    next();
  },

  async mounted() {
    this.isLoading = true;

    const token = sessionStorage.getItem('customer_access_token');

    await this.verifyToken(token);

    if (!this.$store.state.customers.temporal.accountStatus) {
      this.$router.push({ name: 'SignOut' });
      return;
    }

    this.loading = true;
    this.loaded = true;

    this.isLoading = false;

    await Promise.all([
      this.getAll({
        ...this.$route.query,
        token,
      }),
      this.$store.dispatch('customers/customersGetSingle'),
    ]);

    this.isLoading = false;
    this.loading = false;

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.modal) {
        this.modal = false;
      }
    }, false);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', () => {});
  },
  methods: {
    ...mapActions({
      getAll: 'invoices/getStatusAccount',
      verifyToken: 'customers/verifyStatusAccountToken',
    }),
    async downloadCfdis() {
      const now = new Date();
      const { companyId, customerId } = this.$store.state.customers.temporal;

      this.$store.commit('ui/addNotification', {
        type: 'info',
        content: 'Descargando...',
        dateTime: now,
      });

      await this.$store.dispatch(
        'invoice/downloadStatusAccount',
        { companyId, customerId },
      );

      this.$store.commit('ui/deleteNotification', now);
    },
  },
};
</script>

<style scoped>
  .title-container {
    justify-content: space-between;
    align-items: center;
    padding-bottom: 2rem;
  }

  .title {
    margin: 0;
  }

  .empty {
    vertical-align: center;
    text-align: center;
  }

  .action-option {
    display: flex!important;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .close-label {
    margin-top: -8px;
  }

  table th,
  table td {
    vertical-align: middle;
    text-align: center;
  }

  nav.pagination.is-centered:not(:last-child) {
    padding-bottom: 2rem;
  }

  .customer {
    padding: 1rem;
  }

  .box {
    height: 100%;
  }

  /deep/ .container {
    overflow-y: auto;
    min-height: 100px;
    height: 500px !important;
    padding: 5px;
  }
</style>
